import { language as baseSqlLanguage } from 'monaco-editor/esm/vs/basic-languages/sql/sql.js';

/** Агрегатные функции подсвечиваем как predefined (встроенные функции). */
export const SQL_AGGREGATE_FUNCTIONS = new Set([
  'COUNT',
  'SUM',
  'AVG',
  'MIN',
  'MAX',
]);

type MonacoLanguagesApi = {
  languages: {
    setMonarchTokensProvider: (languageId: string, languageDefinition: unknown) => void;
  };
};

let sciplexSqlLanguageConfigured = false;

export function configureSciplexSqlLanguage(monaco: MonacoLanguagesApi): void {
  if (sciplexSqlLanguageConfigured) return;
  sciplexSqlLanguageConfigured = true;

  const keywords = baseSqlLanguage.keywords.filter(
    (keyword) => !SQL_AGGREGATE_FUNCTIONS.has(keyword),
  );

  const builtinFunctions = [
    ...new Set([...baseSqlLanguage.builtinFunctions, ...SQL_AGGREGATE_FUNCTIONS]),
  ];

  monaco.languages.setMonarchTokensProvider('sql', {
    ...baseSqlLanguage,
    keywords,
    builtinFunctions,
  });
}
